var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_material-location-on","dataName":"Icon material-location-on","d":"M13.8,3A6.3,6.3,0,0,0,7.5,9.3c0,4.725,6.3,11.7,6.3,11.7s6.3-6.975,6.3-11.7A6.3,6.3,0,0,0,13.8,3Zm0,8.55A2.25,2.25,0,1,1,16.05,9.3,2.251,2.251,0,0,1,13.8,11.55Z","transform":"translate(-6.75 -2.25)","strokeWidth":"1.5"}));
}

Location.defaultProps = {"width":"14.1","height":"19.869","viewBox":"0 0 14.1 19.869"};

module.exports = Location;

Location.default = Location;
